import React from 'react';
import ReactDOM from 'react-dom';
import PromoTicker from '../components/PromoTicker';
import { initializeI18n } from '../localization/i18n';

// Expose render function globally. props = { messages: [{text, link}], interval, badge }
window.renderPromoTicker = (elementId, props) => {
  const element = document.getElementById(elementId);
  if (!element) return;
  initializeI18n()
    .then(() => {
      ReactDOM.render(<PromoTicker props={props} />, element);
    })
    .catch(() => {
      ReactDOM.render(<PromoTicker props={props} />, element);
    });
};
